/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation SaveSouscriptionActivePolicyMutation($input: SaveSouscriptionActivePolicy_M_souscription_active_policyInput!) {
    saveSouscriptionActivePolicy_M_souscription_active_policy(input: $input) {
      ok
      error
      
    }
  }
`;

export default mutation;
